function contentSize(classMenu, classFooter) {
    var menuHeight = classMenu.innerHeight();
    var footerHeight = classFooter.innerHeight();
    $('.page-404').css('height', 'calc(100vh - ' + (menuHeight + footerHeight) + 'px');
}
jQuery('document').ready(function ($) {
    contentSize($('.menu_container'), $('footer'));
    $(window).resize(function () {
        contentSize($('.menu_container'), $('footer'));
    });
});
